export default function InvoiceMetaGridReadonly({ invoice }) {
  const isSale = invoice.type === 'sale';
  const rows = [
    [invoice.type === 'sale' ? 'Bill To' : 'Supplier', invoice.supplier],
    ['Invoice No.', invoice.invoiceNo],
    ['Invoice Date', invoice.date],
    !isSale && ['Address', invoice.address],
    !isSale && ['Phone', invoice.phone],
    !isSale && ['Due Date', invoice.date],
    !isSale && ['Email', invoice.email],
    !isSale && ['PO Number', invoice.poNumber],
  ].filter(Boolean);

  return (
    <div style={{ padding: '20px 32px 0' }}>
      <div className="meta-section">
        {rows.map(([label, val]) => (
          <div className="meta-cell" key={label}>
            <div className="meta-label">{label}</div>
            <div className="meta-value">{val || '—'}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
